/**
 * @fileoverview Redux Toolkit slice'larını birleştirir.
 * Whitelist/blacklist yönetimi store.js'de redux-persist ile yapılır.
 */

import { combineReducers } from '@reduxjs/toolkit'
import uiReducer       from '../features/ui/uiSlice'
import languageReducer from '../features/language/languageSlice'
import siteLocaleReducer from '../features/siteLocale/siteLocaleSlice'
import portfolioReducer from '../features/portfolio/portfolioSlice'
import leadFormReducer  from '../features/leadForm/leadFormSlice'

const rootReducer = combineReducers({
  ui:        uiReducer,
  language:  languageReducer,
  siteLocale: siteLocaleReducer,
  portfolio: portfolioReducer,
  leadForm:  leadFormReducer,
})

export default rootReducer
